/**
 * @desc 作废
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.PaymentOrderInvalidApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/invalid`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
